<div class="row g-3">
    <div class="col-12">
        <div class="card shadow-sm">
            <div class="card-body">
                <div class="d-flex justify-content-between align-items-start flex-wrap gap-2">
                    <div>
                        <h5 class="card-title mb-1">Teste de integração WhatsApp</h5>
                        <div class="text-muted small">
                            Crie até duas conexões e inicie um teste. O QRCode é parte do teste e aparece após iniciar.
                        </div>
                    </div>

                    <div class="d-flex align-items-center gap-2">
                        <input type="tel" class="form-control form-control-sm" style="max-width: 220px;"
                            placeholder="Telefone destino" [(ngModel)]="targetPhoneNumber" />
                        <button type="button" class="btn btn-primary btn-sm" (click)="startNewTest()"
                            [disabled]="!targetPhoneNumber || targetPhoneNumber.trim().length === 0">
                            Iniciar novo teste
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-12">
        <div class="card shadow-sm">
            <div class="card-body" style="max-height: 85vh; overflow-y: auto;">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <h5 class="card-title mb-0">Histórico de testes</h5>
                </div>

                <div class="text-muted small py-3 text-center" *ngIf="!tests() || tests().length === 0">
                    Nenhum teste iniciado ainda. Clique em
                    <span class="fw-semibold">"Iniciar novo teste"</span>
                    para começar a validação.
                </div>

                <div class="d-flex flex-column gap-2">
                    <div class="border rounded p-2" *ngFor="let test of tests()"
                        [ngClass]="{ 'border-primary bg-light': test === selectedTest() }" (click)="selectTest(test)">
                        <div class="d-flex justify-content-between align-items-center mb-1">
                            <div>
                                <div class="d-flex align-items-center gap-2">
                                    <div class="fw-semibold small">Teste #{{ test.id }}</div>
                                    <span class="badge rounded-pill" [ngClass]="getTestStatusBadgeClass(test)">
                                        {{ getTestStatusLabel(test) }}
                                    </span>
                                </div>
                                <div class="text-muted" style="font-size: 11px;">Iniciado por: {{ test.startedBy }}</div>
                                <div class="text-muted" style="font-size: 11px;">{{ test.createdAt | date: 'short' }}</div>
                            </div>

                            <button type="button" class="btn btn-outline-secondary btn-sm"
                                (click)="toggleTestDetails(test, $event)">
                                {{ isTestExpanded(test) ? 'Ocultar detalhes' : 'Mostrar detalhes' }}
                            </button>
                        </div>

                        <div [ngClass]="{ 'd-none': !isTestExpanded(test) }">
                            <div class="small text-muted mb-1">Conexões do teste:</div>

                            <div class="d-flex flex-column gap-2">
                                <div class="border rounded p-2 bg-white" *ngFor="let conn of test.connectionsStatus">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <div class="small fw-semibold">
                                            {{ conn.connectionId }}
                                            <span *ngIf="conn.whatsAppStatus === 1" class="badge bg-success ms-2">Conectado ao WhatsApp</span>
                                        </div>
                                    </div>

                                    <div class="d-flex gap-2 flex-wrap">
                                        <div class="border rounded bg-light d-flex align-items-center justify-content-center"
                                            style="width: 265px; height: 265px;">
                                            <ng-container *ngIf="conn.qrCode; else qrPlaceholder">
                                                <img [src]="conn.qrCode" alt="QR Code" [style.width.px]="240"
                                                    [style.height.px]="240" />
                                            </ng-container>
                                            <ng-template #qrPlaceholder>
                                                <div class="d-flex flex-column align-items-center justify-content-center">
                                                    <i class="fa fa-qrcode fa-2x text-muted mb-1"></i>
                                                    <div class="text-muted small text-center">Aguardando QRCode</div>
                                                </div>
                                            </ng-template>
                                        </div>

                                        <div class="flex-grow-1">
                                            <div class="d-flex align-items-center flex-wrap">
                                                <div class="d-flex align-items-center me-3 mb-1" *ngFor="let step of conn.steps">
                                                    <div class="rounded-circle border d-flex align-items-center justify-content-center me-1"
                                                        [ngClass]="step.done ? 'bg-success border-success text-white' : 'border-secondary text-muted'"
                                                        style="width: 22px; height: 22px; font-size: 11px;">
                                                        {{ step.done ? '✓' : '' }}
                                                    </div>
                                                    <div class="small">{{ step.label }}</div>
                                                </div>
                                            </div>

                                            <div class="mt-2 pt-2 border-top">
                                                <div class="d-flex flex-column flex-wrap gap-3" style="font-size: 12px;">
                                                    <div class="d-flex align-items-center gap-1">
                                                        <span class="text-muted">Chart:</span>
                                                        <span class="font-monospace">{{ conn.chartVersion }}</span>
                                                    </div>
                                                    <div class="d-flex align-items-center gap-1">
                                                        <span class="text-muted">WAHA:</span>
                                                        <span class="font-monospace">{{ conn.wahaImage }}</span>
                                                    </div>
                                                    <div class="d-flex align-items-center gap-1">
                                                        <span class="text-muted">Nibo WAHA:</span>
                                                        <span class="font-monospace">{{ conn.niboWahaVersion }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>